import React from 'react';

const Footer = () => (
  <footer id='footer' className='footer'>
    <p className='footer--legal'>© 2024 Astra Creative Arts Awards | All Rights Reserved</p>
  </footer>
);

export default Footer;